import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { initTheme } from '@/lib/theme';
import '@/styles/globals.css';

initTheme();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container missing — index.html is malformed');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
